import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { rgba } from "polished";
import styled, { css } from "styled-components";

export const StyledListItem = styled.div<{
  selected: boolean;
  collapsed?: boolean;
}>`
  border: 0 none !important;
  cursor: pointer;
  margin-bottom: 3px;
  transition: all 0.3s ease;
  width: 100%;

  ${({ collapsed }) =>
    collapsed &&
    css`
      width: 100px;
      a {
        overflow: hidden;
      }
    `}

  & .list-item-content {
    overflow: hidden;
    width: 100%;
    color: ${({ theme }) => theme.palette.text.primary}!important;
    display: flex;
    margin-right: 20px;
    border-radius: 0 ${({ theme }) => theme.cardRadius30}
      ${({ theme }) => theme.cardRadius30} 0;
    border: 2px solid ${({ theme }) => rgba(theme.palette.primary.main, 0.1)} !important;
    border-left-color: transparent !important;
    background-color: ${({ theme }) => rgba(theme.palette.primary.main, 0.2)};

    ${({ selected }) =>
      selected &&
      css`
        background-color: ${({ theme }) =>
          rgba(theme.palette.green[6], 0.3)} !important;
      `}

    box-sizing: border-box;
    transition: all 0.3s;

    align-items: center;

    span.ant-typography {
      color: ${({ theme }) => theme.palette.text.primary}!important;
      max-width: ${({ collapsed }) => (collapsed ? "100px" : "auto")};
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
      padding: 8.5px 20px;
    }

    &:hover,
    &:focus,
    &.active {
      color: ${({ theme }) => theme.palette.primary.main};
      background-color: ${({ theme }) => rgba(theme.palette.green[6], 0.2)};
    }
  }

  .actions {
    opacity: 0;
    transition: 0.5s;
    position: absolute;
    right: -5px;

    &:focus {
      opacity: 1;
      right: 20px;
    }
  }

  &:hover {
    .actions {
      opacity: 1;
      right: 20px;
    }
  }
`;

export const StyledListItemContent = styled.div<{
  collapsed?: boolean;
  selected?: boolean;
}>`
  display: flex;
  align-items: center;
  width: ${({ collapsed }) => (collapsed ? "100px" : "auto")};
  padding: ${({ collapsed }) => (collapsed ? "3px 0" : "5px 20px")}!important;

  ${({ selected }) =>
    selected &&
    css`
      background-color: ${({ theme }) => rgba(theme.palette.green[6], 0.3)};
    `}
`;

export const StyledListItemIcon = styled.span`
  font-size: 18px;
  margin-right: 16px;

  [dir="rtl"] & {
    margin-right: 0;
    margin-left: 16px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    margin-right: 20px;

    [dir="rtl"] & {
      margin-right: 0;
      margin-left: 20px;
    }
  }

  & > svg {
    display: block;
  }
`;

export const StyledActions = styled(StyledFlex)`
  justify-content: center;
  background: ${({ theme }) => rgba(theme.palette.primary.main, 0.3)};
  border-radius: 7px;
  z-index: 99999999;

  button {
    margin: 0;
  }
`;
